import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Drafts.css';

interface Image {
  id: number;
  url_imagen: string;
}

interface Text {
  id: number;
  contenido_texto: string;
}

interface Publication {
  id: number;
  url_imagen: string;
  contenido_texto: string;
}

const Drafts: React.FC = () => {
  const [images, setImages] = useState<Image[]>([]);
  const [texts, setTexts] = useState<Text[]>([]);
  const [publications, setPublications] = useState<Publication[]>([]);
  const [selectedImages, setSelectedImages] = useState<number[]>([]);
  const [selectedTexts, setSelectedTexts] = useState<number[]>([]);
  const [selectedPublications, setSelectedPublications] = useState<number[]>([]);
  const [openSection, setOpenSection] = useState<string | null>(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const token = localStorage.getItem('token');        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

        console.log(backendUrl);
        
        const response = await axios.get(`${backendUrl}/drafts/images`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        });
        setImages(response.data);
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    const fetchTexts = async () => {
      try {        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

        console.log(backendUrl);
        
        const response = await axios.get(`${backendUrl}/drafts/texts`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        });
        setTexts(response.data);
      } catch (error) {
        console.error('Error fetching texts:', error);
      }
    };

    const fetchPublications = async () => {
      try {        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

        console.log(backendUrl);
        
        const response = await axios.get(`${backendUrl}/drafts/publications`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        });
        setPublications(response.data);
      } catch (error) {
        console.error('Error fetching publications:', error);
      }
    };

    fetchImages();
    fetchTexts();
    fetchPublications();
  }, []);

  const toggleSelectImage = (id: number) => {
    setSelectedImages((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter(imageId => imageId !== id)
        : [...prevSelected, id]
    );
  };

  const toggleSelectText = (id: number) => {
    setSelectedTexts((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter(textId => textId !== id)
        : [...prevSelected, id]
    );
  };

  const toggleSelectPublication = (id: number) => {
    setSelectedPublications((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter(pubId => pubId !== id)
        : [...prevSelected, id]
    );
  };

  const selectAllImages = () => {
    setSelectedImages(images.map(image => image.id));
  };

  const deselectAllImages = () => {
    setSelectedImages([]);
  };

  const selectAllTexts = () => {
    setSelectedTexts(texts.map(text => text.id));
  };

  const deselectAllTexts = () => {
    setSelectedTexts([]);
  };

  const selectAllPublications = () => {
    setSelectedPublications(publications.map(publication => publication.id));
  };

  const deselectAllPublications = () => {
    setSelectedPublications([]);
  };

  const deleteSelectedDrafts = async () => {
    try {        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);
      
        await axios.post(`${backendUrl}/delete-drafts`, {
        ids: {
          images: selectedImages,
          texts: selectedTexts,
          publications: selectedPublications
        }
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      // Update state after deletion
      setPublications(publications.filter(pub => !selectedPublications.includes(pub.id)));
      setImages(images.filter(img => !selectedImages.includes(img.id)));
      setTexts(texts.filter(txt => !selectedTexts.includes(txt.id)));
      setSelectedImages([]);
      setSelectedTexts([]);
      setSelectedPublications([]);
    } catch (error) {
      console.error('Error deleting drafts:', error);
    }
  };

  const deleteAllDrafts = async () => {
    try {
      await axios.post('http://localhost:3001/drafts/deleteAll', {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      // Update state after deletion
      setPublications([]);
      setImages([]);
      setTexts([]);
      setSelectedImages([]);
      setSelectedTexts([]);
      setSelectedPublications([]);
    } catch (error) {
      console.error('Error deleting all drafts:', error);
    }
  };

  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="drafts-container">
      <div className="drafts-section">
        <h2 onClick={() => toggleSection('publications')}>Publicaciones</h2>
        {openSection === 'publications' && (
          <div className="section-content">
            <button className="buttons" onClick={selectAllPublications}>Seleccionar todo</button>
            <button className="buttons" onClick={deselectAllPublications}>Deseleccionar todo</button>
            <div className="draft-gallery">
              {publications.map((publication) => (
                <div key={publication.id} className="draft-item">
                  <input
                    type="checkbox"
                    checked={selectedPublications.includes(publication.id)}
                    onChange={() => toggleSelectPublication(publication.id)}
                  />
                  <img src={publication.url_imagen} alt="Imagen" />
                  <p>{publication.contenido_texto}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="drafts-section">
        <h2 onClick={() => toggleSection('images')}>Imágenes</h2>
        {openSection === 'images' && (
          <div className="section-content">
            <button className="buttons" onClick={selectAllImages}>Seleccionar todo</button>
            <button className="buttons" onClick={deselectAllImages}>Deseleccionar todo</button>
            <div className="draft-gallery">
              {images.map((image) => (
                <div key={image.id} className="draft-item">
                  <input
                    type="checkbox"
                    checked={selectedImages.includes(image.id)}
                    onChange={() => toggleSelectImage(image.id)}
                  />
                  <img src={image.url_imagen} alt="Imagen" />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="drafts-section">
        <h2 onClick={() => toggleSection('texts')}>Textos</h2>
        {openSection === 'texts' && (
          <div className="section-content">
            <button className='buttons' onClick={selectAllTexts}>Seleccionar todo</button>
            <button className="buttons" onClick={deselectAllTexts}>Deseleccionar todo</button>
            <div className="draft-gallery">
              {texts.map((text) => (
                <div key={text.id} className="draft-item">
                  <input
                    type="checkbox"
                    checked={selectedTexts.includes(text.id)}
                    onChange={() => toggleSelectText(text.id)}
                  />
                  <p>{text.contenido_texto}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className='botones' >
        <button className="buttons" onClick={deleteSelectedDrafts}>Eliminar Seleccionados</button>
        <button className="buttons" onClick={deleteAllDrafts}>Eliminar Todos</button>
      </div>
      <div className="perfil-carpetas">
          <h3>Carpetas</h3>
          <div className="carpetas-list">
            <div className="carpeta">Textos</div>
            <div className="carpeta">Imágenes</div>
            <div className="carpeta">Borradores</div>
            <div className="carpeta añadir">Añadir</div>
          </div>
        </div>
    </div>
  );
};

export default Drafts;
